import { Component, ElementRef, EventEmitter, Input, AfterViewInit, OnInit, OnChanges, Output, ViewChild, SimpleChanges } from '@angular/core';

import { ApiError, BaseFilterCollapse, BaseFilterCollapseService, ConfigService, MessageService } from '../../../core';
import { ConfigEmpresa, isTipoMercadoMarca } from '../../configuracoes/app/empresa';
import { UsuarioFilter } from './usuario-filter';
import { usuarioSituacoes } from '../usuario-situacao';
import { usuarioPerfis } from '../usuario-perfil';
import { ItemMarca, ItemMarcaCrudHttpService } from '../../item-marca';
import { UsuarioFilterItemMarca } from './usuario-filter-item-marca';
import { Representante } from '../../pessoa/representante';

@Component({
    selector: 'sgt-usuario-filter-collapse',
    templateUrl: './usuario-filter-collapse.component.html',
    styleUrls: ['./usuario-filter-collapse.component.less']
})
export class UsuarioFilterCollapseComponent implements BaseFilterCollapse, OnInit, OnChanges, AfterViewInit {
    configEmpresa: ConfigEmpresa;

    @Input() isCollapsedInDefault = false;
    isCollapsedIn = false;
    @ViewChild('filterCollapse') filterCollapse: ElementRef;
    collapseIcon = 'fas fa-caret-down';
    isFilterDirty = false;

    @Input() filter: UsuarioFilter;
    @Output() filterInitialized = new EventEmitter<any>();
    situacoes = usuarioSituacoes;
    perfis = usuarioPerfis

    constructor(private messageService: MessageService,
                private baseFilterCollapseService: BaseFilterCollapseService,
                private configService: ConfigService,
                private itemMarcaCrudHttpService: ItemMarcaCrudHttpService) { }

    ngOnInit() {
        this.configEmpresa = this.configService.getEmpresa();

        this.initFilter();
    }

    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            if (propName === 'isCollapsedInDefault') {
                if (changes[propName].isFirstChange) {
                    setTimeout(() => {
                        this.isCollapsedIn = changes[propName].currentValue;
                    }, 100);
                }
            }
        }
    }

    ngAfterViewInit() {
        if (!this.isCollapsedInDefault) {
            jQuery(this.filterCollapse.nativeElement).css('display', 'none');
        }
    }

    /** Verifica se o Tipo de Mercado da empresa é por Marca */
    isTipoMercadoMarca(): boolean {
        if (!this.configEmpresa) {
            return false;
        }
        return isTipoMercadoMarca(this.configEmpresa.tipoMercado);
    }

    /** Inicializa o filtro */
    private initFilter() {
        // Executando as pesquisas assíncronas
        const p1 = this.searchMarcas();
        Promise.all([p1])
            .then(() => {
                // this.isFilterDirty = true;
                this.filterInitialized.emit(); // Emitindo o evento de que o filtro foi inicializado
            })
            .catch(() => {});
    }

    /** Abre/Fecha o filtro */
    toggleCollapse() {
        this.baseFilterCollapseService.toggleCollapse(this);
    }

    /** Abre o filtro */
    open() {
        this.baseFilterCollapseService.open(this);
    }

    /** Fecha o filtro */
    close() {
        this.baseFilterCollapseService.close(this);
    }

    /** Limpa o filtro */
    clear() {
        this.baseFilterCollapseService.clear(this);
    }

    /** Verifica se a empresa é exportadora */
    isEmpresaExportadora(): boolean {
        if (!this.configEmpresa) {
            return false;
        }
        return this.configEmpresa.exportadora;
    }

     /** Pesquisa as marcas cadastradas e vinculadas ao usuário */
     private searchMarcas(): Promise<any> {
        return new Promise<void>((resolve, reject) => {
            if (!this.isTipoMercadoMarca()) {
                resolve();
                return;
            }

            this.itemMarcaCrudHttpService.search()
                .subscribe(
                    entities => {
                        this.createMarcas(entities);
                        resolve();
                    },
                    (error: ApiError) => {
                        this.messageService.error(error.message, 'Erro ao pesquisar as marcas cadastradas', error);
                        reject();
                    }
                );

        });
    }

    /** Cria as marcas para o filter */
    private createMarcas(entities: ItemMarca[]) {
        this.filter.itensMarcas = [];
        if (!entities) {
            return;
        }

        entities.forEach(entity => {
            const itemMarca = new UsuarioFilterItemMarca(entity.id, entity.nome);
            this.filter.itensMarcas.push(itemMarca);
        })
    }

    /** Ao alterar o representante */
    onChangeRepresentante(representante: Representante) {
        if (representante) {
            this.filter.idRepresentante = representante.id;
            this.isFilterDirty = true;
        } else {
            this.filter.idRepresentante = null;
        }
    }
}
